// Documentation:
// https://swimlane.gitbook.io/ngx-charts/examples/line-area-charts/stacked-area-chart

export let stacked_area_chart_data = [
  {
    name: 'Nav',
    series: [],
  },
  {
    name: 'Finn',
    series: [],
  },
  {
    name: 'Indeed',
    series: [],
  },
  {
    name: 'Facebook',
    series: [],
  },
  {
    name: 'Other',
    series: [
      {
        name: new Date(2018, 4, 4, 20, 0, 0),
        value: 1,
      },
      {
        name: new Date(2018, 4, 4, 23, 0, 0),
        value: 1,
      },
    ],
  },
  {
    name: 'Direct',
    series: [
      {
        name: new Date(2018, 4, 4, 6, 0, 0),
        value: 1,
      },
      {
        name: new Date(2018, 4, 4, 18, 0, 0),
        value: 5,
      },
      {
        name: new Date(2018, 4, 4, 19, 0, 0),
        value: 2,
      },
      {
        name: new Date(2018, 4, 4, 20, 0, 0),
        value: 17,
      },
      {
        name: new Date(2018, 4, 4, 23, 0, 0),
        value: 5,
      },
    ],
  },
];

export let stacked_area_chart_ui = {
  // View: the dimensions of the chart [width, height].
  // If left undefined, the chart will fit to the parent container size
  // view: [700, 400],
  showXAxis: true,
  showYAxis: true,
  gradient: false,
  showLegend: true,
  showXAxisLabel: true,
  animations: true,
  showYAxisLabel: true,
  legendTitle: 'Referrals',
  xAxisLabel: '',
  yAxisLabel: 'Page views',
  colorScheme: {
    domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA'],
  },
};
